import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { BrandGroups, BrandGroupsVariables } from "./types/BrandGroups";
import {
  BrandGroupsDetails,
  BrandGroupsDetailsVariables
} from "./types/BrandGroupsDetails";

const brandGroupsList = gql`
  ${pageInfoFragment}
  query BrandGroups(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sortBy: BrandGroupSortingInput
    $filter: BrandGroupInput
    $fetchPopularStores: Boolean
  ) {
    brandGroups(
      after: $after
      before: $before
      first: $first
      last: $last
      sortBy: $sortBy
      filter: $filter
      fetchPopularStores: $fetchPopularStores
    ) {
      edges {
        node {
          id
          name
          code
          vertical
          classification
          tags {
            name
            id
          }
          image {
            url
            alt
          }
          isSmacAffiliate
          dynamicLink
        }
      }

      totalCount
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export const useBrandGroupsListQuery = makeQuery<
  BrandGroups,
  BrandGroupsVariables
>(brandGroupsList);

const brandGroupsDetails = gql`
  query BrandGroupsDetails($id: ID!) {
    brandGroup(id: $id) {
      id
      name
      code
      classification
      vertical
      tags {
        name
        id
      }
      image {
        url
        alt
      }
      isSmacAffiliate
      dynamicLink
      sellers {
        id
        name
        legalName
      }
    }
  }
`;
export const useBrandGroupsDetailsQuery = makeQuery<
  BrandGroupsDetails,
  BrandGroupsDetailsVariables
>(brandGroupsDetails);
